import React from 'react';
import { Alert } from 'react-bootstrap';
import { CheckCircle, XCircle, AlertTriangle, Info } from 'lucide-react';

/**
 * Reusable component for displaying status notifications
 * @param {Object} props - Component properties
 * @param {Object} props.notification - Notification object with type and message
 * @param {string} props.notification.type - Type of notification (success, danger, warning, info)
 * @param {string} props.notification.message - Notification message
 * @param {boolean} props.notification.useHtml - Whether to render message as pre-wrapped text
 */
const StatusNotification = ({ notification }) => {
    if (!notification) return null;

    // Map Bootstrap alert variants to our CSS classes
    const getAlertClass = (type) => {
        switch (type) {
            case 'success':
                return 'text-success border-success/50';
            case 'danger':
                return 'text-destructive border-destructive/50';
            case 'warning':
                return 'text-warning border-warning/50';
            default:
                return '';
        }
    };

    // Get the appropriate icon based on notification type
    const getStatusIcon = (type) => {
        switch (type) {
            case 'success':
                return <CheckCircle size={16} />;
            case 'danger':
                return <XCircle size={16} />;
            case 'warning':
                return <AlertTriangle size={16} />;
            default:
                return <Info size={16} />;
        }
    };

    return (
        <Alert
            variant={notification.type}
            className={`mt-3 text-left ${getAlertClass(notification.type)}`}
        >
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <span style={{ display: 'inline-block', marginRight: '6px' }}>
                    {getStatusIcon(notification.type)}
                </span>
                <span>
                    {notification.useHtml ? (
                        <div style={{ whiteSpace: 'pre-wrap' }}>
                            {notification.message}
                        </div>
                    ) : (
                        notification.message
                    )}
                </span>
            </div>
        </Alert>
    );
};

export default StatusNotification;
